import { useTranslation } from "react-i18next";
import "./invoiceStatus.scss";

const STATUS_CONFIG: Record<number, { key: string; modifier: string }> = {
    0: { key: "open",       modifier: "grey"   },
    2: { key: "paid",       modifier: "green"  },
    4: { key: "overdue",    modifier: "red"    },
    5: { key: "writtenOff", modifier: "purple" },
    6: { key: "deleted",    modifier: "dark"   },
};

interface InvoiceStatusProps {
    status: number;
    unsent?: boolean;
    dunning?: number;
    /** A send attempt (portal link or PDF email) was made and failed — distinct from
     *  "just hasn't been sent yet" so it doesn't get lost in the normal unsent queue. */
    emailFailed?: boolean;
}

export default function InvoiceStatus({ status, unsent, dunning, emailFailed }: InvoiceStatusProps) {
    const { t } = useTranslation();
    if (unsent && status === 0 && emailFailed) {
        return (
            <span className="invoice-status invoice-status--orange">
                {t("filters.status.sendFailed")}
            </span>
        );
    }
    if (unsent && status === 0) {
        return (
            <span className="invoice-status invoice-status--blue">
                {t("filters.status.unsent")}
            </span>
        );
    }
    if (status === 0 && dunning && dunning >= 1) {
        return (
            <span className="invoice-status invoice-status--red">
                {t("filters.status.overdue")}
            </span>
        );
    }
    const config = STATUS_CONFIG[status] ?? { key: "unknown", modifier: "grey" };
    return (
        <span className={`invoice-status invoice-status--${config.modifier}`}>
            {t(`filters.status.${config.key}`)}
        </span>
    );
}
